import columns from '../../../../../react-table/helpers/columns';

export const mrdConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['carditTransportLastLeg.transport'] !== null) {
      if (rowInfo.row['mrd.registeredTransport'] !== rowInfo.row['carditTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['mrd.registeredTransport'] !== rowInfo.row['preconTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] === null) && (rowInfo.row['predesTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['mrd.registeredTransport'] !== rowInfo.row['predesTransportLastLeg.transport']) {
        className = 'text-red';
      }
    }
  }
  return {
    className,
  };
};

export const resdit21ConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['carditTransportLastLeg.transport'] !== null) {
      if (rowInfo.row['resdit21.transport'] !== rowInfo.row['carditTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['resdit21.transport'] !== rowInfo.row['preconTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] === null) && (rowInfo.row['predesTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['resdit21.transport'] !== rowInfo.row['predesTransportLastLeg.transport']) {
        className = 'text-red';
      }
    }
  }
  return {
    className,
  };
};

export const resconConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['carditTransportLastLeg.transport'] !== null) {
      if (rowInfo.row['rescon.transport'] !== rowInfo.row['carditTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['rescon.transport'] !== rowInfo.row['preconTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] === null) && (rowInfo.row['predesTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['rescon.transport'] !== rowInfo.row['predesTransportLastLeg.transport']) {
        className = 'text-red';
      }
    }
  }
  return {
    className,
  };
};

export const resdesConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['carditTransportLastLeg.transport'] !== null) {
      if (rowInfo.row['resdes.transport'] !== rowInfo.row['carditTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['resdes.transport'] !== rowInfo.row['preconTransportLastLeg.transport']) {
        className = 'text-red';
      }
    } else if ((rowInfo.row['carditTransportLastLeg.transport'] === null) && (rowInfo.row['preconTransportLastLeg.transport'] === null) && (rowInfo.row['predesTransportLastLeg.transport'] !== null)) {
      if (rowInfo.row['resdes.transport'] !== rowInfo.row['predesTransportLastLeg.transport']) {
        className = 'text-red';
      }
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'predes.receptacleId').withWidth(270)),
        new DateTimeColumn('Despatch closed date', 'predes.despatchClosedDate'),
      ],
    },
    {
      Header: 'PREDES transport - last leg',
      columns: [
        new TextColumn('Transport', 'predesTransportLastLeg.transport'),
        new TextColumn('Arrival location', 'predesTransportLastLeg.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'predesTransportLastLeg.arrivalDate'),
        new DateTimeColumn('LAT', 'predesTransportLastLeg.lat'),
      ],
    },
    {
      Header: 'PRECON transport - last leg',
      columns: [
        new TextColumn('Transport', 'preconTransportLastLeg.transport'),
        new TextColumn('Arrival location', 'preconTransportLastLeg.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'preconTransportLastLeg.arrivalDate'),
      ],
    },
    {
      Header: 'CARDIT transport - last leg',
      columns: [
        new TextColumn('Transport', 'carditTransportLastLeg.transport'),
        new TextColumn('Arrival location', 'carditTransportLastLeg.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'carditTransportLastLeg.arrivalDate'),
      ],
    },
    {
      Header: 'MRD',
      columns: [
        new DateTimeColumn('Registration time', 'mrd.registrationTime'),
        new TextColumn('Registered transport', 'mrd.registeredTransport').withGetProps(mrdConditionalProps),
      ],
    },
    {
      Header: 'RESDIT 21',
      columns: [
        new DateTimeColumn('Event date', 'resdit21.eventDate'),
        new TextColumn('Transport', 'resdit21.transport').withGetProps(resdit21ConditionalProps),
        new TextColumn('Arrival location', 'resdit21.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'resdit21.arrivalDate'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new DateTimeColumn('First scan date', 'rescon.firstScanDate'),
        new TextColumn('Transport', 'rescon.transport').withGetProps(resconConditionalProps),
        new TextColumn('Arrival location', 'rescon.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'rescon.arrivalDate'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('First scan', 'resdes.firstScan'),
        new TextColumn('Transport', 'resdes.transport').withGetProps(resdesConditionalProps),
        new TextColumn('Arrival location', 'resdes.arrivalLocation'),
        new DateTimeColumn('Arrival date', 'resdes.arrivalDate'),
      ],
    },
  ];
};
